import type { ParsedPublicMessage } from '@module/types/centrifuge/messageTypes';
import {
  isMemberKickOutMessage,
  type MemberKickOutMessage,
} from '@module/types/centrifuge/public-message/etcMessageTypes';
import type { MessageHandler, MessageHandlerAction, MessageHandlerContext } from '../types';

export class MemberKickOutHandler implements MessageHandler {
  constructor(
    private customAction?:
      | MessageHandlerAction<MemberKickOutMessage>
      | Promise<MessageHandlerAction<MemberKickOutMessage>>,
  ) {}

  canHandle(payload: ParsedPublicMessage): boolean {
    return isMemberKickOutMessage(payload);
  }

  async handle(payload: MemberKickOutMessage, context: MessageHandlerContext): Promise<void> {
    if (this.customAction === null || this.customAction === undefined) return;

    const isMatchedUser = payload.data.message.idx === context.userInfo?.idx;
    if (!isMatchedUser) return;

    if (typeof this.customAction === 'function') {
      this.customAction(payload, context);
      return;
    }

    // 기본 동작
    context.dispose?.();
    context.disconnectSocket?.();

    const message = `${payload.data.message.type}님께서 ${payload.data.message.name}님을 강퇴시켰습니다.`;

    if (context.hsms) {
      await context.hsms.openModal(
        'Confirm',
        { title: message, isShowCancelButton: false, confirmText: '確認' },
        { size: 'mid' },
      );
      context.router?.push('/');
    } else if (context.pushModal) {
      context.pushModal({
        type: 'CONFIRM_MODAL',
        options: {
          description: message,
          onClose: () => {
            context.router?.push('/');
            context.popModal?.();
          },
        },
      });
    }
  }
}
